import Loader from "react-spinners/ClipLoader";
import "./Button.scss";

const Button = ({
  buttonType,
  text,
  isLoading,
  prefixIcon,
  suffixIcon,
  icon,
  buttonRef,
  disabled,
  className,
  ...restProps // ✅ only safe props (onClick, type, id, etc.) go here
}) => {
  const renderButton = () => {
    const commonProps = {
      disabled,
      ref: buttonRef,
      className: `btn ${className || ""}`,
      ...restProps,
    };

    switch (buttonType) {
      case "primary":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__primary`}>
            {prefixIcon}
            {isLoading ? <Loader color="#fff" size={14} /> : text}
            {suffixIcon}
          </button>
        );

      case "secondary":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__secondary`}>
            {prefixIcon} {text} {suffixIcon}
          </button>
        );

      case "light":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__light`}>
            {prefixIcon} {text} {suffixIcon}
          </button>
        );

      case "icon":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__light`}>
            {icon}
          </button>
        );

      case "danger":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__danger`}>
            {prefixIcon} {text} {suffixIcon}
          </button>
        );

      case "outline":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__outline`}>
            {prefixIcon}
            {isLoading ? <Loader color="var(--primary)" size={14} /> : text}
            {suffixIcon}
          </button>
        );

      case "button":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__apply`}>
            {text} {icon}
          </button>
        );

      case "dropdown":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__dropdown`}>
            {text} {icon}
          </button>
        );

      case "text":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__text`}>
            {text}
          </button>
        );

      case "amountBtn":
        return (
          <button
            {...commonProps}
            className={`quickAmt no-border ${commonProps.className} btn-xs btn-outline-secondary`}
          >
            {text}
          </button>
        );

      case "link":
        return (
          <button {...commonProps} className={`${commonProps.className} emr-btn__link`}>
            {prefixIcon} {text} {suffixIcon}
          </button>
        );

      default:
        return (
          <button {...commonProps} className={`${commonProps.className} primary icon`}>
            {text} {icon}
          </button>
        );
    }
  };

  return renderButton();
};

export default Button;
